import type { ChannelMiniEntity } from "@/features/channel/domain/entities/ChannelMiniEntity"
import type { UserGroupEntity } from "@/features/userGroup/domain/entities/UserGroupEntity"
import type { BranchMiniEntity } from "@/features/branch/domain/entities/BranchMiniEntity"
import type { RegionMiniEntity } from "@/features/region/domain/entities/RegionMiniEntity"
import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity"

export class CouponFilterEntity {
    searchWord?: string 
    page?: number 
    limit?: number 
     validFrom?: string 
    validTo?: string 
    redeemCode?: string 
    region?: RegionMiniEntity
    branch?: BranchMiniEntity
    group?: UserGroupEntity
    channel?: ChannelMiniEntity
    user?: UserMiniEntity
    hasOnItemDiscount?: boolean 
    hasOnDeliveryDiscount?: boolean 
     
}
 
